import { apiGetJobSchedulingList } from "./jobScheduling.api";

const SET_JOB_SCHEDULING_LIST = "SET_JOB_SCHEDULING_LIST";
const SET_SELECTED_DAY = "SET_SELECTED_DAY";

const initialState = {
  jobSchedulingList: [],
  selectedDay: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_JOB_SCHEDULING_LIST:
      return {
        ...state,
        scheduledJobs: action.payload.scheduledJobs,
        unscheduledJobs: action.payload.unscheduledJobs,
        agendaEvents: action.payload.agendaEvents,
      };
    case SET_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.payload,
      };
    default:
      return state;
  }
};

export const actionGetJobSchedulingList = (keyword, searchType) => {
  keyword = keyword !== "" ? keyword : null;
  const data = {
    searchParam: keyword,
    searchType: searchType,
  };
  return async (dispatch) => {
    try {
      const result = await apiGetJobSchedulingList(data);

      if (result) {
        dispatch({
          type: SET_JOB_SCHEDULING_LIST,
          payload: result,
        });
      }
    } catch (e) {
      dispatch({ type: SET_JOB_SCHEDULING_LIST, payload: [] });
    }
  };
};

export const actionSetSelectedDay = (day) => {
  return {
    type: "SET_SELECTED_DAY",
    payload: day,
  };
};
